import clsx from 'clsx'

export function Button({ className, fontSize, ...props }) {
  return (
    <button
      className={clsx(
        'inline-flex items-center gap-2 justify-center rounded-md py-2 px-3 outline-offset-2 transition active:transition-none',
        'bg-zinc-900 font-semibold text-zinc-100 hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70',
        className,
        fontSize || 'text-sm',
      )}
      {...props}
    />
  )
}
